/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Activity,
  CreateActivityDto,
  DeletePartnerActivitiesRequest,
  UpdateActivityDto,
} from '../models/index';
import {
    ActivityFromJSON,
    ActivityToJSON,
    CreateActivityDtoFromJSON,
    CreateActivityDtoToJSON,
    DeletePartnerActivitiesRequestFromJSON,
    DeletePartnerActivitiesRequestToJSON,
    UpdateActivityDtoFromJSON,
    UpdateActivityDtoToJSON,
} from '../models/index';

export interface CreatePartnerCallsActivitiesByUserIdRequest {
    userId: number;
    createActivityDto: CreateActivityDto;
}

export interface DeletePartnerActivitiesOperationRequest {
    deletePartnerActivitiesRequest: DeletePartnerActivitiesRequest;
}

export interface DeletePartnerActivityRequest {
    activityId: number;
}

export interface GetPartnerCallsActivitiesByUserIdRequest {
    userId: number;
}

export interface UpdatePartnerActivityRequest {
    activityId: number;
    updateActivityDto: UpdateActivityDto;
}

/**
 * 
 */
export class ActivityApi extends runtime.BaseAPI {

    /**
     * Create activity for partner calls by user id
     */
    async createPartnerCallsActivitiesByUserIdRaw(requestParameters: CreatePartnerCallsActivitiesByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateActivityDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling createPartnerCallsActivitiesByUserId().'
            );
        }

        if (requestParameters['createActivityDto'] == null) {
            throw new runtime.RequiredError(
                'createActivityDto',
                'Required parameter "createActivityDto" was null or undefined when calling createPartnerCallsActivitiesByUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/activity/user/{userId}/partner/calls`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateActivityDtoToJSON(requestParameters['createActivityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateActivityDtoFromJSON(jsonValue));
    }

    /**
     * Create activity for partner calls by user id
     */
    async createPartnerCallsActivitiesByUserId(requestParameters: CreatePartnerCallsActivitiesByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateActivityDto> {
        const response = await this.createPartnerCallsActivitiesByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete partner activities by their ids
     */
    async deletePartnerActivitiesRaw(requestParameters: DeletePartnerActivitiesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deletePartnerActivitiesRequest'] == null) {
            throw new runtime.RequiredError(
                'deletePartnerActivitiesRequest',
                'Required parameter "deletePartnerActivitiesRequest" was null or undefined when calling deletePartnerActivities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/activity`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeletePartnerActivitiesRequestToJSON(requestParameters['deletePartnerActivitiesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete partner activities by their ids
     */
    async deletePartnerActivities(requestParameters: DeletePartnerActivitiesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePartnerActivitiesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete partner activity by id
     */
    async deletePartnerActivityRaw(requestParameters: DeletePartnerActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['activityId'] == null) {
            throw new runtime.RequiredError(
                'activityId',
                'Required parameter "activityId" was null or undefined when calling deletePartnerActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/activity/{activityId}`;
        urlPath = urlPath.replace(`{${"activityId"}}`, encodeURIComponent(String(requestParameters['activityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete partner activity by id
     */
    async deletePartnerActivity(requestParameters: DeletePartnerActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deletePartnerActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner activities by user id
     */
    async getPartnerCallsActivitiesByUserIdRaw(requestParameters: GetPartnerCallsActivitiesByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Activity>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getPartnerCallsActivitiesByUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/activity/user/{userId}/partner/calls`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivityFromJSON));
    }

    /**
     * Get partner activities by user id
     */
    async getPartnerCallsActivitiesByUserId(requestParameters: GetPartnerCallsActivitiesByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Activity>> {
        const response = await this.getPartnerCallsActivitiesByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update partner activity by id
     */
    async updatePartnerActivityRaw(requestParameters: UpdatePartnerActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Activity>> {
        if (requestParameters['activityId'] == null) {
            throw new runtime.RequiredError(
                'activityId',
                'Required parameter "activityId" was null or undefined when calling updatePartnerActivity().'
            );
        }

        if (requestParameters['updateActivityDto'] == null) {
            throw new runtime.RequiredError(
                'updateActivityDto',
                'Required parameter "updateActivityDto" was null or undefined when calling updatePartnerActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/activity/{activityId}`;
        urlPath = urlPath.replace(`{${"activityId"}}`, encodeURIComponent(String(requestParameters['activityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateActivityDtoToJSON(requestParameters['updateActivityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityFromJSON(jsonValue));
    }

    /**
     * Update partner activity by id
     */
    async updatePartnerActivity(requestParameters: UpdatePartnerActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Activity> {
        const response = await this.updatePartnerActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
